export const SLO_CHART_TYPES = ['RequestBasedSloChart', 'WindowsBasedSloChart'];

export const isSLOChartType = (type: string): boolean => SLO_CHART_TYPES.includes(type);
